import { Divider, Form, Spin } from "antd";
import { type FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { ApplicationConfigurations } from "../components/appConfigsPanelComponent/ApplicationConfigurations";
import { mapFormModelToCollapseModel } from "../components/appConfigsUtils";
import { useLoadFormConfigsQuery } from "../services/server/AppConfigsApi";
import type { FormJson } from "../types/AppConfigsTypes";

export interface ApplicationConfigurationsPageProps {}

export const ApplicationConfigurationsPage: FC<ApplicationConfigurationsPageProps> = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const hasAccess = canAccess(ResourceName.APP_CONFIGURATIONS, "canRead");

    const dataGroup = getAssignedDataGroup();

    const { data: configData, isFetching: configIsFetching } = useLoadFormConfigsQuery({ dataGroupCode: dataGroup?.code || "" });
    const jsonModelData = configData?.applicationConfiguration;

    useEffect(() => {
        const collapseModelStateData = mapFormModelToCollapseModel(jsonModelData as FormJson, t);
        form.setFieldsValue({ applicationConfigurations: collapseModelStateData });
    }, [form, jsonModelData, t]);

    return (
        <Spin spinning={configIsFetching}>
            <PageLayout>
                {hasAccess ? (
                    <>
                        <PageTitle translationKey="menu.appConfigs" />
                        <Divider />
                        <ApplicationConfigurations value={mapFormModelToCollapseModel(jsonModelData as FormJson, t)} />
                    </>
                ) : (
                    <NoAccessLayout />
                )}
            </PageLayout>
        </Spin>
    );
};
